import { render, staticRenderFns } from "./StudioLessonContent.vue?vue&type=template&id=4ac0d926&scoped=true&"
import script from "./StudioLessonContent.vue?vue&type=script&lang=js&"
export * from "./StudioLessonContent.vue?vue&type=script&lang=js&"
import style0 from "./StudioLessonContent.vue?vue&type=style&index=0&id=4ac0d926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac0d926",
  null
  
)

export default component.exports